import { Injector } from "@angular/core";
import { Art57NodeUtils } from "./Node/Art57Node/Art57NodeUtils";
import { QueryConditionsNode } from "./Node/QueryConditionsNode";
import { QueryResultNode } from "./Node/QueryResultNode";
import { LookupGetService } from "../service/lookup-service/lookup-get.service";

export class ToolTipUtil {

    static showTooltip(node: any, injector:Injector): string | null {
  
        let originaltext: string | null = node.paginationControl.criteria;
        let text = '';
    
        if (originaltext) {

          //translate fields
          if (node instanceof QueryResultNode) {

            const criterias = originaltext.split("~");
            if (criterias.length>0){
                criterias.forEach((criteria:String)=>{

                  if (criteria==='') { return; }

                    var criteriaKey = criteria!.split(":")[0];
                    var criteriaValue = criteria!.split(":")[2];
                    //Replace the key by key label
                    const field = (node.conditionsNode as QueryConditionsNode)!.data.fields.find((f:any)=>f.key===criteriaKey);     
// JMBL                    const field = Art57NodeUtils.findFirstChildNodeOfType(node.parent!.parent!,QueryConditionsNode)!.data.fields.find((f:any)=>f.key===criteriaKey);     
                    criteria = criteria!.replace(new RegExp(`\\b${field.key}\\b`, 'g'), field.props.label);
                    //Replace the value by text value only for lookups
                    if (field.props.lookup && (field.type==="conditionQuerySelectType" 
                      || field.type==="fieldQueryType"
                      || field.type==="conditionQuerySelectTypeWithDefaultValue")){
                      criteria = criteria!.replace(criteriaValue, 
                                          injector.get(LookupGetService).retrieveValueFromCache(field.props.lookup, criteriaValue) );  
                    }
                    text= text + criteria + '\n';

                });
            }
 
          }
    
          //translate operation
          if (node instanceof QueryResultNode) {
            text = text!.replaceAll(':eq:', " is ")
            text = text!.replaceAll(':eq:', " matches ")
            text = text!.replaceAll(':cn:', " contains ")
            text = text!.replaceAll(':sw:', " starts with ")
            text = text!.replaceAll(':ew:', " ends with ")
            text = text!.replaceAll(':in:', " is ")
            text = text!.replaceAll(':ge:', " greater equal than ")
            text = text!.replaceAll(':le:', " lower equal than ")
            text = text!.replaceAll(':gt:', " greater than ")
            text = text!.replaceAll(':lt:', " lower than ")
            text = text!.replaceAll(':is:', " is ")
            text = text!.replaceAll(':vu:', " is ")
            text = text!.replaceAll('~', '\n');
          }
        } else {
          text = "No conditions specified";
        }
    
        return text;
      }
  
      static displayTooltip(node: any): boolean {
        return node instanceof QueryResultNode;
      }

}
